import { render } from "./BillingPage.vue?vue&type=template&id=20f7a735&scoped=true"
import script from "./BillingPage.vue?vue&type=script&lang=js"
export * from "./BillingPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "@/css/AppLayout.css?vue&type=style&index=1&lang=css&external"
import "./BillingPage.vue?vue&type=style&index=2&id=20f7a735&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f7a735"]])

export default __exports__